export default __webpack_public_path__ + "static/media/blue-multi-knob.a9177ae9.png";